<uis-slider ngSkipHydration [items]="data.content.items">
	<ng-template let-item="item" let-isCurrentItem="isCurrentItem">
		<uis-testimonial [testimonial]="item" [shouldDisplayRating]="isCurrentItem"></uis-testimonial>
	</ng-template>
</uis-slider>
